import { useRequest } from '@@/plugin-request';
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript';
import type { default as baseRequest } from './request';
import type {
  BaseOptions,
  BaseResult,
  OptionsWithFormat,
  PaginatedFormatReturn,
  PaginatedParams,
  PaginatedOptionsWithFormat,
} from '@umijs/plugins/node_modules/@ahooksjs/use-request/es/types';

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof baseRequest>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof baseRequest>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

// 添加一个额外的泛型 TFormat，用于描述格式化结果的函数类型
export interface BasePaginatedOptions<T, TFormat = any>
  extends Omit<BaseOptions<PaginatedFormatReturn<T>, PaginatedParams>, 'paginated'> {
  paginated?: true;
  defaultPageSize?: number;
  formatResult?: (res: T) => TFormat;
}

export default function makeRequestHook<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult extends ReturnType<typeof baseRequest>,
>(requestFunc: Request<TRequestData, TRequestConfig, TRequestResult>) {
  type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
  type P = Parameters<Request<TRequestData, TRequestConfig, TRequestResult>>;
  type UseRequestResult<R = Data, U = R> = BaseResult<U, P>;

  function useCustomRequest(
    options?: OptionsWithFormat<Data, P, Data, Data>,
  ): UseRequestResult<Data>;
  function useCustomRequest(options?: BaseOptions<Data, P>): UseRequestResult<Data>;
  function useCustomRequest(
    options?: PaginatedOptionsWithFormat<Data, Data, Data>,
  ): UseRequestResult<Data>;
  function useCustomRequest<T>(options?: BasePaginatedOptions<Data, T>): UseRequestResult<Data, T>;
  function useCustomRequest<T>(options?: any) {
    return useRequest<Data, P, T, T>(requestFunc, options);
  }

  return useCustomRequest;
}
// return (
//   options?: unknown,
// ) =>
//   useUmiRequest<Data, P>(requestFunc, options);
// type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
// return function useRequest(
//   _requestData: TRequestData,
//   options: Options<any, any, any, any> = {},
// ): BaseResult<Data, any> {
//   return useUmiRequest(requestFunc, options);
// };

// type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
// return function useRequest(requestData: TRequestData, options) {
//   // 一个简单的 Hook 实现，实际项目可结合其他库使用，比如：
//   // @umijs/hooks 的 useRequest (https://github.com/umijs/hooks)
//   // swr (https://github.com/zeit/swr)
//
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState<Data>();
//
//   useEffect(() => {
//     request(requestData).then((res) => {
//       setLoading(false);
//       setData(res as any);
//     });
//   }, [JSON.stringify(requestData)]);
//
//   return {
//     loading,
//     data,
//   };
// };
